import { render } from "./AccordsNote.vue?vue&type=template&id=01663afa"
import script from "./AccordsNote.vue?vue&type=script&lang=js"
export * from "./AccordsNote.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__